/**
 * React hooks for API calls
 */

import { useMemo } from 'react'
import { useAuth } from '@usoftware/auth-react'
import { createApiClient, type ApiClient } from './client'

/**
 * Get an API client that uses the current user's access token
 */
export function useApiClient(): ApiClient {
  const { getAccessToken } = useAuth()

  return useMemo(() => createApiClient(getAccessToken), [getAccessToken])
}
